// action - state management
import { DEFAULT_ROLE, FIREBASE_STATE_CHANGED, LOGIN, LOGOUT, REGISTER } from './actions';
import storage from 'redux-persist/lib/storage';

// ==============================|| ACCOUNT REDUCER ||============================== //

const initialState = {
    isLoggedIn: false,
    isInitialized: false,
    user: null,
    defaultRole: 'anon'
};

const accountReducer = (state = initialState, action) => {
    switch (action.type) {
        case REGISTER: {
            const { user } = action.payload;
            return {
                ...state,
                user
            };
        }
        case LOGIN: {
            const { user } = action.payload;
            return {
                ...state,
                isLoggedIn: true,
                isInitialized: true,
                user
            };
        }
        case LOGOUT: {
            return {
                ...state,
                isInitialized: true,
                isLoggedIn: false,
                user: null,
                defaultRole: 'anon'
            };
        }
        case FIREBASE_STATE_CHANGED: {
            return {
                ...state
            };
        }
        case DEFAULT_ROLE: {
            const { role } = action.payload;
            return {
                ...state,
                defaultRole: role
            };
        }
        default: {
            return { ...state };
        }
    }
};

const appReducer = (state, action) => {
    if (action.type === LOGOUT) {
        // this applies to all keys defined in persistConfig(s)
        storage.removeItem(`pbx-${state.defaultRole}`);
        storage.removeItem(`pbx-common`);
        storage.removeItem(`pbx-profile`);
        state = {};
    }
    return accountReducer(state, action);
};

export default appReducer;
